module.exports = __webpack_public_path__ + "static/media/toggleSettings.d1b6e345.svg";